import React from 'react';
import { progressBlock } from './constants';
export function ProgressStackItem({ item }) {
    const { value, color, className, theme, title, content, loading } = item;
    const modifiers = {
        loading,
    };
    if (typeof color === 'undefined') {
        modifiers.theme = theme || 'default';
    }
    if (Number.isFinite(value)) {
        return (React.createElement("div", { className: progressBlock('item', modifiers, className), style: { width: `${value}%`, backgroundColor: color }, title: title }, content));
    }
    return null;
}
